<template>
    <div name="invite" class="wrapper">
        <div class="page">
            <!-- 헤더 -->
            <div class="button-header">
                <img @click="back" style="width: 22px; cursor: pointer;" src="../assets/arrow_back.png" />
                <span class="button-header-text">초대하기</span>
            </div>

            <!-- 탭 -->
            <div class="tab-bar">
                <div
                    class="tab"
                    :class="{ active: currentTab === 'invite' }"
                    @click="currentTab = 'invite'"
                >
                    초대하기
                </div>
                <div
                    class="tab"
                    :class="{ active: currentTab === 'code' }"
                    @click="currentTab = 'code'"
                >
                    초대코드 입력
                </div>
            </div>
            <div class="innder-banner-area">
                소개 배너 외부 링크 영역
            </div>
            <!-- 초대하기 탭 컨텐츠 -->
            <div class="content" v-if="currentTab === 'invite'">
                <div class="invite-card">
                    <span class="invite-title">친구에게 솔닥을 알려주세요</span>
                    <span class="invite-desc">초대 링크를 공유하면 친구가 솔닥 컨시어지 서비스를 이용할 수 있어요.</span>
                    <div class="invite-code-box">
                        <span class="invite-code-label">내 초대코드</span>
                        <span class="invite-code">{{ inviteCode || '-' }}</span>
                    </div>
                </div>
            </div>

            <!-- 초대코드 입력 탭 컨텐츠 -->
            <div class="content" v-if="currentTab === 'code'">
                <div class="invite-card">
                    <span class="invite-title">초대코드를 입력해 주세요</span>
                    <span class="invite-desc" v-if="isAlreadyReferred">이미 초대코드를 입력하였습니다.</span>
                    <span class="invite-desc" v-else>친구에게 받은 초대코드를 입력하면 혜택을 받을 수 있어요.</span>
                    <div class="input-box">
                        <input
                            class="code-input"
                            v-model="inputCode"
                            placeholder="초대코드 입력"
                            maxlength="20"
                            :disabled="isAlreadyReferred"
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- 하단 고정 버튼 -->
        <div class="bottom-buttons" v-if="currentTab === 'invite'">
            <div class="invite-button" @click="copyInviteLink">
                <span>초대 링크 복사하기</span>
            </div>
            <div class="invite-button kakao" @click="shareKakao">
                <span>카카오톡으로 공유하기</span>
            </div>
        </div>
        <div class="bottom-buttons" v-if="currentTab === 'code'">
            <div
                class="invite-button"
                :class="{ disabled: !inputCode || isAlreadyReferred }"
                @click="submitCode"
            >
                <span>{{ isAlreadyReferred ? '입력완료' : '입력 하기' }}</span>
            </div>
        </div>
        <!-- 토스트 -->
        <div class="toast" v-if="toastMessage">{{ toastMessage }}</div>
    </div>
</template>

<script>
import cookies from '@/utilities/cookie.js';
import Constant from '@/constant';
import {mapState} from 'vuex';
export default {
    name: 'invite',
    data() {
        return {
            currentTab: 'invite',
            inviteCode: '',
            inputCode: '',
            access_token: null,
            isLoading: false,
            toastMessage: '',
            isAlreadyReferred: false,
        }
    },
    mounted() {
        // TODO: API로 내 초대코드 조회
        ChannelIO('shutdown')
        const code = this.$route.query.code;
        if (code) {
            this.currentTab = 'code';
            this.inputCode = code;
        }

        this.access_token = cookies.getLocalStorage("access_token");
        if(this.access_token === null || this.access_token === undefined || this.access_token === '')
        {
            this.access_token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'invite', code: code || undefined}})
        }
        else
        {
            this.fetchInviteCode();
        }

    },
    methods: {
        back() {
            this.$router.push({path: '/home'})
        },
        copyInviteLink() {
            var link = process.env.LOGIN_URI + '/invite?code=' + (this.inviteCode || '');
            navigator.clipboard.writeText(link).then(() => {
                this.showToastMessage('복사가 완료되었습니다');
            });
        },
        shareKakao() {
            var link = process.env.LOGIN_URI + '/invite?code=' + (this.inviteCode || '');
            Kakao.Share.sendDefault({
                objectType: 'feed',
                content: {
                    title: '병원 갈 필요 없이 전화로 진료 받을 수 있어요.',
                    description: '연속혈당측정기 첫 구매 시 네이버페이 3만원 혜택을 드려요!',
                    imageUrl: 'https://baro.soldoc.co.kr/thumbnail.png',
                    link: {
                        mobileWebUrl: link,
                        webUrl: link
                    }
                },
                buttons: [
                    {
                        title: '초대 받기',
                        link: {
                            mobileWebUrl: link,
                            webUrl: link
                        }
                    }
                ]
            });
        },
        submitCode() {
            if (!this.inputCode || this.isAlreadyReferred) return;
            this.$store.dispatch(Constant.APPLY_INVITE_CODE, {code: this.inputCode, token: this.access_token})
                .then(() => {
                    this.fetchInviteCode(true);
                })
                .catch((err) => {
                    if (err && err.data && err.data.title) {
                        this.showToastMessage(err.data.title);
                    }
                })
        },
        fetchInviteCode(showToast) {
  
            this.$store.dispatch(Constant.FETCH_INVITE_CODE, {token: this.access_token})
                .then((res) => {
                    if (res && res.data) {
                        this.inviteCode = res.data.referral_code || '';
                        if (res.data.referred_by_code !== null && res.data.referred_by_code !== '' && res.data.referred_by_code !== undefined) {
                            this.isAlreadyReferred = true;
                            this.inputCode = res.data.referred_by_code;
                            if (showToast) {
                                this.showToastMessage('등록이 완료되었습니다.');
                            }
                            if (this.$route.query.code) {
                                this.access_token = cookies.deleteLocalStorage("access_token");
                                this.$router.replace({path: '/invite', query: {}});
                            }
                        }
                    }
                })
                .catch(() => {
                    this.access_token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'invite'}})
                })
        },
        showToastMessage(msg) {
            this.toastMessage = msg;
            setTimeout(() => { this.toastMessage = ''; }, 2000);
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }
    .page {
        width: 100%;
        min-height: 100vh;
        background: #FFF;
    }
    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }
    .button-header {
        width: 100%;
        height: 56px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 16px;
        border-bottom: 1px solid #E8EAEE;
    }
    .button-header-text {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        margin-left: 12px;
    }

    /* 탭 */
    .tab-bar {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #E8EAEE;
    }
    .tab {
        flex: 1;
        text-align: center;
        padding: 14px 0;
        font-family: Pretendard;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #6B7684;
        cursor: pointer;
        border-bottom: 2px solid transparent;
        transition: all 0.2s;
    }
    .tab.active {
        color: #184FA1;
        font-weight: 600;
        border-bottom: 2px solid #184FA1;
    }

    /* 컨텐츠 */
    .content {
        padding: 12px 16px 140px 16px;
    }
    .invite-card {
        display: flex;
        flex-direction: column;
    }
    .invite-title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
    }
    .invite-desc {
        color: #6B7684;
        font-family: Pretendard;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-top: 8px;
    }

    /* 초대코드 표시 */
    .invite-code-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #F3F5F8;
        border-radius: 6px;
        padding: 16px 20px;
        margin-top: 24px;
    }
    .invite-code-label {
        color: #6B7684;
        font-family: Pretendard;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
    }
    .invite-code {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-weight: 600;
        line-height: 22px;
    }

    /* 하단 고정 */
    .bottom-buttons {
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 600px;
        box-sizing: border-box;
        padding: 12px 16px;
        padding-bottom: calc(12px + env(safe-area-inset-bottom));
        background: #FFF;
        border-top: 1px solid #E8EAEE;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    .bottom-buttons .invite-button {
        margin-top: 0;
    }

    /* 버튼 */
    .invite-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 48px;
        border-radius: 6px;
        background: #184FA1;
        color: #FFF;
        font-family: Pretendard;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        cursor: pointer;
        margin-top: 12px;
        box-sizing: border-box;
    }
    .invite-button.kakao {
        background: #FEE500;
        color: #191919;
    }
    .invite-button.disabled {
        background: #CCD3DB;
        cursor: default;
    }

    /* 초대코드 입력 */
    .input-box {
        margin-top: 24px;
    }
    .code-input {
        width: 100%;
        height: 48px;
        border-radius: 6px;
        border: 1px solid #E8EAEE;
        box-sizing: border-box;
        padding: 0 16px;
        font-family: Pretendard;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: #1E1E1E;
        outline: none;
    }
    .code-input:disabled {
        background: #F3F5F8;
        color: #6B7684;
    }
    .code-input:focus {
        border-color: #184FA1;
    }
    .code-input::placeholder {
        color: #CCD3DB;
    }

    /* 토스트 */
    .toast {
        position: fixed;
        bottom: 80px;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(30, 30, 30, 0.85);
        color: #FFF;
        font-family: Pretendard;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        padding: 12px 24px;
        border-radius: 8px;
        z-index: 9999;
    }
    /* 광고 배너 */
    .innder-banner-area {
        width: 100%;
        height: 72px;
        background: red;
        margin-top: 16px;
    }    
</style>



// WEBPACK FOOTER //
// src/page/Invite.vue